<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card
            class="strpied-tabled-with-hover"
            body-classes="table-full-width table-responsive"
          >
            <template slot="header">
              <div style="margin-left: 44%; margin-bottom: 20px">
                <button
                  class="btn btn-primary btn-primary-add"
                  @click="AddProduct"
                >
                  <i class="fas fa-plus" style="font-weight: 900"></i>
                </button>
                <h4
                  class="card-title"
                  style="display: inline-block; margin-right: 52%"
                >
                  قائمة المنتجات
                </h4>
              </div>
              <div class="search-bar">
                <input
                  type="text"
                  style="
                    border: 1px solid lightgray;
                    border-radius: 5px;
                    padding: 1%;
                    width: 100%;
                    margin-bottom: 15px;
                  "
                  placeholder="ما اسم المنتج الذي تبحث عنه؟"
                  v-model="searchKey"
                  @input="performSearch"
                />
              </div>
            </template>
            <table
              class="table-hover table-striped tableStyle"
              style="width: 100%"
            >
              <thead>
                <tr>
                  <th
                    v-for="(column, index) in table1.columns"
                    :key="index"
                    :class="{ hiddenCol: column === 'الرقم التسلسلي' }"
                  >
                    {{ column }}
                  </th>
                  <th>الإجراءات</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, rowIndex) in table1.data" :key="rowIndex">
                  <td class="hiddenCol">{{ row["الرقم التسلسلي"] }}</td>
                  <td>
                    <div v-if="row.loading">
                      <div class="spinner-border text-primary" role="status">
                        <span class="sr-only">Loading...</span>
                      </div>
                    </div>
                    <div v-else v-html="row['الصورة']"></div>
                  </td>
                  <td>{{ row["الاسم"] }}</td>
                  <td>{{ row["الطول"] }} {{ $t("cm") }}</td>
                  <td>{{ row["العرض"] }} {{ $t("cm") }}</td>
                  <td>
                    <button class="btn btn-info" @click="productDetails(row)">
                      <i class="fas fa-eye icon-primary"></i>
                    </button>
                    <button
                      class="btn btn-primary btn-primary-add"
                      @click="editProduct(row)"
                    >
                      <i class="fas fa-edit icon-primary"></i>
                    </button>
                    <button
                      class="btn btn-danger"
                      @click="deleteProduct(row['الرقم التسلسلي'])"
                    >
                      <i class="fas fa-trash-alt icon-danger"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </card>
        </div>
      </div>
    </div>
    <nav v-if="pagination.totalPages > 1">
      <ul class="pagination justify-content-center">
        <li
          class="page-item"
          v-for="page in pagination.totalPages"
          :key="page"
          :class="{ active: pagination.currentPage === page }"
        >
          <a class="page-link" @click="changePage(page, searchKey)">{{
            page
          }}</a>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
import Axios from "../../../Axios";
import Swal from "sweetalert2";
import LTable from "src/Dashboard/SharedComponents/Table.vue";
import Card from "src/Dashboard/SharedComponents/Card.vue";
import AddProduct from "src/Dashboard/pages/Products/AddProduct.vue";

const tableColumns = ["الرقم التسلسلي", "الصورة", "الاسم", "الطول", "العرض"];
export default {
  components: {
    LTable,
    Card,
    AddProduct,
  },
  data() {
    return {
      table1: {
        columns: [...tableColumns],
        data: [],
      },
      pagination: {
        currentPage: 1,
        totalPages: 1,
      },
      searchKey: "",
      searchResults: [],
    };
  },
  methods: {
    performSearch() {
      Axios.get(`/dashboard/products`, {
        params: {
          limit: 6,
          searchkey: this.searchKey,
          page: this.pagination.currentPage,
        },
      })
        .then((response) => {
          // Update table data with search results
          this.table1.data = response.data.products.map((product) => {
            if (
              product.imagee &&
              product.imagee.type === "Buffer" &&
              Array.isArray(product.imagee.data)
            ) {
              const buffer = Buffer.from(product.imagee.data);
              const base64imagee = buffer.toString("base64");
              product.imagee = `data:imagee/jpeg;base64,${base64imagee}`; // Adjust MIME type if needed
            }
            console.log(product);
            return {
              "الرقم التسلسلي": product.id,
              الصورة: `<img src="${product.imagee}" :alt="product.name" class="user-card-img" style="border-radius:10px;">`,
              الاسم: product.name,
              الطول: product.height,
              العرض: product.depth,
            };
          });
          // Update pagination values based on the response
          this.pagination.currentPage = response.data.currentPage;
          this.pagination.totalPages = response.data.totalPages;
        })
        .catch((error) => {
          this.table1.data = []; // Clear the table data on error
          // console.error(error);
        });
    },

    editProduct(product) {
      this.$router.push({
        name: "edit-product",
        params: { id: product["الرقم التسلسلي"] },
        props: { productData: product },
      });
    },
    productDetails(product) {
      this.$router.push({
        name: "product-details",
        params: { id: product["الرقم التسلسلي"] },
        props: { productData: product },
      });
    },
    AddProduct() {
      this.$router.push("/admin/add-product");
    },
    deleteProduct(id) {
      // Show SweetAlert confirmation dialog before deletion
      Swal.fire({
        title: "هل أنت متأكد؟",
        text: "هل تريد حقًا حذف هذا المنتج؟",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "نعم",
        cancelButtonText: "إلغاء",
        dangerMode: true,
      }).then((result) => {
        if (result.isConfirmed) {
          // The user clicked "نعم", perform the deletion
          Axios.delete(`/product/${id}`)
            .then((response) => {
              // If deletion is successful, update the table data
              this.table1.data = this.table1.data.filter(
                (row) => row["الرقم التسلسلي"] !== id
              );

              // Show success message using SweetAlert
              Swal.fire("تم الحذف!", "تم حذف المنتج بنجاح.", "success");
            })
            .catch((error) => {
              // console.error(error);

              // Show error message using SweetAlert
              Swal.fire("خطأ!", "حدث خطأ أثناء الحذف.", "error");
            });
        }
      });
    },

    changePage(page, searchKey) {
      this.pagination.currentPage = page;
      this.fetchData(page, searchKey);
    },
    fetchData(page = this.pagination.currentPage, searchKey = this.searchKey) {
      Axios.get("/dashboard/products", {
        headers: {
          lang: "ar",
        },
        params: {
          page: page,
          limit: 6,
          searchkey: searchKey, // Pass the searchKey parameter to the API request
        },
      })
        .then((response) => {
          // console.log(response.data.products[0].multilingualData);
          this.table1.data = response.data.products.map((product) => {
            // console.log(product);
            if (
              product.imagee &&
              product.imagee.type === "Buffer" &&
              Array.isArray(product.imagee.data)
            ) {
              const buffer = Buffer.from(product.imagee.data);
              const base64imagee = buffer.toString("base64");
              product.imagee = `data:imagee/jpeg;base64,${base64imagee}`; // Adjust MIME type if needed
            }
            // Initially, set loading to true
            const row = {
              "الرقم التسلسلي": product.id,
              الصورة: `<img src="${product.imagee}" :alt="product.name" class="user-card-img" style="border-radius:10px;">`,
              الاسم: product.name,
              "الرقم التسلسلي": product.id,
              الصورة: `<img src="${product.imagee}" :alt="product.name" class="user-card-img" style="border-radius:10px;">`,
              الاسم: product.name,
              الطول: product.height,
              العرض: product.depth,
            };
            return row;
          });
          this.pagination.totalPages = response.data.totalPages;
        })
        .catch((error) => {
          // console.error(error);
        });
    },
  },
  mounted() {
    this.fetchData();
  },
};
</script>

<style>
.tableStyle {
  text-align: center;
}

.hide-column {
  display: none;
}

.btn-info {
  color: #17a2b8;
  font-size: 20px;
  border: none;
  font-weight: 800;
  margin-left: 3%;
}

* {
  font-family: "Kufi", "Poppins", Arial;
}
</style>
